export const paymentStatusConstants = {
    PastDue: "Past Due",
    UptoDate: "Upto Date",
    FullyPaid: "Fully Paid",
    WriteOff: "WriteOff",
    Dismissed: "Dismissed",
    Pending: "Pending",
    NoContract: "No Contract"
}